import { SeatAvailabilityStatus } from '@vista-digital/ocapi-types/v1';
export const isSeatDetailsAvailable = (seatDetails) => {
    const { isSelectable, availabilityStatus } = seatDetails;
    return isSelectable && availabilityStatus === SeatAvailabilityStatus.Available;
};
